export const socialMediaData = [
  {
    src: '/images/home/community/twitter.svg',
    url: 'https://twitter.com/VVS_finance',
  },
  {
    src: '/images/home/community/medium.svg',
    url: 'https://medium.com/vvs-finance',
    imgScale: 1.8,
  },
  {
    src: '/images/home/community/vector.svg',
    url: 'https://discord.gg/V2957zMsmg',
  },
  {
    src: '/images/home/community/shape.svg',
    url: 'https://t.me/VVSFinance',
  },
  {
    src: '/images/home/community/youtube.svg',
    url: 'https://www.youtube.com/channel/UCKVdjPL9VWaKWV8tiYT-yKA',
  },
]

export const socialMediaDataVvsGotchi = [
  {
    src: '/images/home/community/twitter.svg',
    url: 'https://twitter.com/VVS_finance',
  },
  {
    src: '/images/home/community/medium.svg',
    url: 'https://medium.com/@MinerMole',
    imgScale: 1.8,
  },
  {
    src: '/images/home/community/vector.svg',
    url: 'https://discord.gg/V2957zMsmg',
  },
  {
    src: '/images/home/community/shape.svg',
    url: 'https://t.me/VVSFinance',
  },
  {
    src: '/images/home/community/youtube.svg',
    url: 'https://www.youtube.com/channel/UCKVdjPL9VWaKWV8tiYT-yKA',
  },
]
